import { PieChart } from './PieChart';
import { Legend, LegendItem } from './Legend/Legend';
import React, { useCallback, useState } from 'react';
import { EChartsOption } from 'echarts-for-react';

interface PieChartCustomLegend {
  name: string;
  // eslint-disable-next-line
  chartData: any[];
  // eslint-disable-next-line
  legendData: LegendItem[];
  height?: string;
  width?: string;
  option?: EChartsOption;
  onDocClick: (data: string) => void;
}

export const PieChartCustomLegend: React.FC<PieChartCustomLegend> = ({
  chartData,
  name,
  // eslint-disable-next-line
  legendData,
  height,
  width,
  onDocClick,
  ...rest
}) => {
  // eslint-disable-next-line
  const [activeItemIndex, setActiveItemIndex] = useState<number | null>(null);

  const onMouseOver = useCallback(
    ({ dataIndex, name }: { dataIndex: number | null; name: string | '' }) => {
      setActiveItemIndex(dataIndex);
      onDocClick(name);
    },
    [setActiveItemIndex, onDocClick],
  );

  // const onMouseOver = (dataIndex: any) => {
  //   setActiveItemIndex(dataIndex);
  //   console.log(dataIndex.name);
  // };
  // const onMouseOut = useCallback(() => setActiveItemIndex(null), [setActiveItemIndex]);

  // const onClick = useCallback(({ dataIndex }: { dataIndex: number | null }) => console.log(dataIndex), []);
  const onEvents = {
    // mouseover: onMouseOver,
    // mouseout: onMouseOver,
    click: onMouseOver,
  };

  return (
    <>
      <PieChart
        data={chartData}
        name={name}
        showLegend={false}
        height={height}
        width={width}
        onEvents={onEvents}
        {...rest}
      />
      <Legend legendItems={legendData} activeItemIndex={activeItemIndex} />
    </>
  );
};
